import { Tooltip } from "react-bootstrap";
import { injectIntl } from "react-intl";
import { intlShape } from "../../shapes";
import NamurIcon from "../NamurIcon";
import ContextualHelp from "../Contextuals/ContextualHelp";
import CustomOverlayTrigger from "../CustomOverlayTrigger";

type OwnProps = {
  id?: string;
  translationKey?: string;
  icon?: string;
  label?: string;
  value?: string;
  toolTip?: string;
  intl: intlShape;
  breakValue?: boolean;
  children?: React.ReactNode;
  headerSuffix?: React.ReactNode;
  isNamurIcon?: boolean;
  className?: string;
  contextHelperTitle?: string;
  contextHelperChildren?: React.ReactNode;
};

const defaultProps: Partial<OwnProps> = {
  isNamurIcon: false,
  contextHelperTitle: undefined,
  contextHelperChildren: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function DetailsItem({
  id,
  translationKey,
  label,
  value,
  children,
  intl,
  icon,
  toolTip,
  breakValue,
  isNamurIcon,
  className,
  headerSuffix,
  contextHelperTitle,
  contextHelperChildren,
}: Props) {
  const displayLabel = label || intl.formatMessage({ id: translationKey });
  let displayIcon = null;
  if (icon) {
    displayIcon = isNamurIcon ? (
      <NamurIcon type={icon} size={24} />
    ) : (
      <span className={icon} />
    );
  }

  const displayTooltip = toolTip ? (
    <Tooltip id="tooltip">{toolTip}</Tooltip>
  ) : null;

  const displayValue = toolTip ? (
    <div
      className={
        breakValue ? "details-item-value break-all" : "details-item-value"
      }
    >
      <CustomOverlayTrigger placement="right" overlay={displayTooltip}>
        <span>
          {displayIcon} {value || "-"}
        </span>
      </CustomOverlayTrigger>
    </div>
  ) : (
    <div
      className={
        breakValue ? "details-item-value break-all" : "details-item-value"
      }
    >
      <div className={isNamurIcon ? "details-item-namur-value" : ""}>
        {displayIcon} <span>{value || children || "-"}</span>
      </div>
    </div>
  );

  const contextHelper = contextHelperTitle ? (
    <ContextualHelp title={contextHelperTitle} interactive>
      {contextHelperChildren}
    </ContextualHelp>
  ) : null;

  const style = className ? `details-item ${className}` : "details-item";
  return (
    <div id={id} className={style}>
      <div className="details-item-name">
        {displayLabel}
        {contextHelper}
        {headerSuffix}
      </div>
      {displayValue}
    </div>
  );
}

DetailsItem.defaultProps = defaultProps;

export default injectIntl(DetailsItem);
